const messages = {
  title: "Despre BS Plus",
  description: "About page description",
};

export default {
  messages,
};
